import { render, staticRenderFns } from "./PageHeadlineWithLink.vue?vue&type=template&id=bbaceb4a&scoped=true&"
import script from "./PageHeadlineWithLink.vue?vue&type=script&lang=js&"
export * from "./PageHeadlineWithLink.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadlineWithLink.vue?vue&type=style&index=0&id=bbaceb4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaceb4a",
  null
  
)

export default component.exports